import React, {useEffect} from 'react';
import AIBackground from "../functions/AIBackground";
import { Link } from 'react-router-dom';

const HomePage = () => {

     useEffect(() => {
        document.body.classList.add("home");

        return () => {
            document.body.classList.remove("home");
        };
    }, []);


    const downloadAPK = async () => {
  const response = await fetch("Pandapick.apk");
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "PandaPick.apk";
  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
};

    return(

        <>
        <div className='hero-section'>
            <AIBackground />

    <div className="container">

        <div className='dark-bannertext'>
        <h1>
        <span className='highlight'>AI</span> Smart Attendance Tool <br></br> <span> Start For Free</span>
        </h1>
        {/*Track attendance with AI precision, real-time location, and smart analytics. A better way to manage your workforce, anywhere, anytime.  */}
        <p> Right Now <strong> <i class="fa-brands fa-android"></i>  Android APP</strong> is Available / IOS Will Update 10 SEPT 2026 </p>
        <br></br>


        <div className='d-flex flex-column flex-md-row gap-3 align-item-center justify-content-center'>


 <Link to="#"
  onClick={(e) => {
    e.preventDefault();
    downloadAPK();
  }} className="btn-start-free">
  <i class="fa-solid fa-download"></i> Download App For Employee
</Link>

</div>

        </div>

    </div>
        </div>
        </>
    )

}

export default HomePage;